import React, {useEffect} from "react"
import choiceController from "../../store/pageControllers/ChoiceController"
import {Field, Fields, FieldsGroup, WaCheckbox} from "../../lib/wa-2.0"
import {observer} from "mobx-react-lite"
import "./SelectProductsPage.scss"
import "./react-checkbox-tree.css"
import StepNavigation from "../../components/StepNavigation";
import {appPages} from "../../App"
import {SelectProductsCategoriesOrSets} from "../../components/SelectProductsCategoriesOrSets";
import {useHistory} from "react-router"

export const SelectProductsPage = observer(() => {

    const history = useHistory();

    useEffect(() => {
        choiceController.loadSettings()
    }, [])
    return <div>
        <h1>1. Выбор товаров</h1>
        <Fields>
            <FieldsGroup>
                <SelectProductsCategoriesOrSets
                    selectType={choiceController.exportAll ? "all" : "collection"}
                    selectedCategories={choiceController.checkedCategories}
                    selectedSets={choiceController.chosenSets}
                    productCollectionType={choiceController.type}
                    changeState={(state) => {
                        const exportAll = state.selectType === 'all';
                        const checkedCategories = state.selectedCategories ?? []
                        const chosenSets = state.selectedSets ?? []
                        if (choiceController.exportAll !== exportAll) {
                            choiceController.exportAll = exportAll
                            // choiceController.saveExportAll()
                        }
                        if (checkedCategories !== choiceController.checkedCategories) {
                            choiceController.checkedCategories = checkedCategories
                            // choiceController.saveSelectedCategories()
                        }
                        if (chosenSets !== choiceController.chosenSets) {
                            choiceController.chosenSets = chosenSets
                            // choiceController.saveSelectedSets()
                        }

                        choiceController.type = state.productCollectionType ?? 'categories'
                    }}
                />


                <Field label={'Выгружать скрытые товары'}>
                    <WaCheckbox
                        fontSize={'16px'}
                        checked={choiceController.exportConditions?.hidden}
                        onChange={(event: { target: { checked: number | boolean } }) => choiceController.setExportCondition("hidden", event.target.checked)}
                    />
                </Field>
                <Field label={'Выгружать товары, которых нет в наличии'}>
                    <WaCheckbox
                        fontSize={'16px'}
                        checked={choiceController.exportConditions?.unavailable}
                        onChange={(event: { target: { checked: number | boolean } }) => choiceController.setExportCondition("unavailable", event.target.checked)}
                    />
                </Field>
                <Field label={'Выгружать товары с остатком ∞'}>
                    <WaCheckbox
                        fontSize={'16px'}
                        checked={choiceController.exportConditions?.infinity}
                        onChange={(event: { target: { checked: number | boolean } }) => choiceController.setExportCondition("infinity", event.target.checked)}
                    />
                </Field>
                <Field label={'Не выгружать товары с ценой ниже'}>
                    <input type={"number"}
                           value={choiceController.exportConditions?.minPrice}
                           onChange={(event) => choiceController.setExportCondition("minPrice", +event.target.value)}
                    />
                    RUB
                </Field>
            </FieldsGroup>
        </Fields>
        <StepNavigation next={undefined} back={undefined} save_next={()=>{choiceController.saveAll().then(()=>history.push(appPages.categoriesComparison))}}/>
    </div>
})